import React from 'react';
import { F90H } from '../../../services/p930hApi';
import { dateToInput, inputToDate, getEventTypeLabel } from '../helpers';
import FieldError from '../../../components/FieldError';

interface Tab1Props {
  formData: Partial<F90H>;
  isEditing: boolean;
  isFieldDisabled: (key: string) => boolean;
  getField: (key: keyof F90H) => F90H[keyof F90H];
  setField: (key: keyof F90H, value: F90H[keyof F90H]) => void;
  getFieldError: (field: string) => string | undefined;
}

const Tab1EventForm: React.FC<Tab1Props> = React.memo(({
  formData, isEditing, isFieldDisabled, getField, setField, getFieldError,
}) => {
  return (
    <div className="form-sections">
      <div className="form-section odd">
        <span className="section-tag">基本資料</span>
        <div className="form-grid">
          <label className="required">日期</label>
          <div>
            <input
              type="date"
              value={dateToInput(getField('f90h_01') as string)}
              onChange={e => setField('f90h_01', inputToDate(e.target.value) as string)}
              disabled={isFieldDisabled('f90h_01')}
            />
            <FieldError error={getFieldError('f90h_01')} />
          </div>

          <label>事件代碼</label>
          <div>
            <input
              type="text"
              value={(getField('f90h_11') as string) || ''}
              onChange={e => setField('f90h_11', e.target.value)}
              disabled={isFieldDisabled('f90h_11')}
              maxLength={12}
            />
            <FieldError error={getFieldError('f90h_11')} />
          </div>

          <label>事件類型</label>
          <div>
            <select
              value={getField('f90h_12') as number || 0}
              onChange={e => setField('f90h_12', Number(e.target.value) as unknown as F90H[keyof F90H])}
              disabled={isFieldDisabled('f90h_12')}
            >
              <option value={0}>-- 請選擇 --</option>
              <option value={1}>{getEventTypeLabel(1)}</option>
              <option value={2}>{getEventTypeLabel(2)}</option>
              <option value={3}>{getEventTypeLabel(3)}</option>
            </select>
            <FieldError error={getFieldError('f90h_12')} />
          </div>

          <label>簡碼</label>
          <div>
            <input
              type="text"
              value={(getField('f90h_13') as string) || ''}
              onChange={e => setField('f90h_13', e.target.value)}
              disabled={isFieldDisabled('f90h_13')}
              maxLength={10}
            />
          </div>

          <label className="required">事件名稱</label>
          <div style={{ gridColumn: 'span 3' }}>
            <input
              type="text"
              value={(getField('f90h_14') as string) || ''}
              onChange={e => setField('f90h_14', e.target.value)}
              disabled={isFieldDisabled('f90h_14')}
              maxLength={60}
            />
            <FieldError error={getFieldError('f90h_14')} />
          </div>

          <label>詳細說明</label>
          <div className="span-full" style={{ gridColumn: '2 / -1' }}>
            <textarea
              value={(getField('f90h_15') as string) || ''}
              onChange={e => setField('f90h_15', e.target.value)}
              disabled={isFieldDisabled('f90h_15')}
              rows={4}
            />
          </div>
        </div>
      </div>

      <div className="form-section even">
        <span className="section-tag">相關代碼</span>
        <div className="form-grid">
          <label>代碼 1</label>
          <input
            type="text"
            value={(getField('f90h_21') as string) || ''}
            onChange={e => setField('f90h_21', e.target.value)}
            disabled={isFieldDisabled('f90h_21')}
            maxLength={5}
          />

          <label>代碼 2</label>
          <input
            type="text"
            value={(getField('f90h_22') as string) || ''}
            onChange={e => setField('f90h_22', e.target.value)}
            disabled={isFieldDisabled('f90h_22')}
            maxLength={5}
          />

          <label>代碼 3</label>
          <input
            type="text"
            value={(getField('f90h_23') as string) || ''}
            onChange={e => setField('f90h_23', e.target.value)}
            disabled={isFieldDisabled('f90h_23')}
            maxLength={5}
          />

          <label>代碼 4</label>
          <input
            type="text"
            value={(getField('f90h_24') as string) || ''}
            onChange={e => setField('f90h_24', e.target.value)}
            disabled={isFieldDisabled('f90h_24')}
            maxLength={5}
          />
        </div>
      </div>

      <div className="form-section odd">
        <span className="section-tag">稽核資訊</span>
        <div className="form-grid">
          <label>建立人員</label>
          <input type="text" value={(formData.f90h_91 as string) || ''} disabled />

          <label>建立日期</label>
          <input type="text" value={dateToInput(formData.f90h_92 as string)} disabled />

          <label>稽核</label>
          <input type="text" value={(formData.f90h_93 as string) || ''} disabled />
        </div>
      </div>
    </div>
  );
});

Tab1EventForm.displayName = 'Tab1EventForm';
export default Tab1EventForm;
